import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { SendCouponsProps } from "../../customwidgets/coupons-report/types";
import { IconButton, TextField, MenuItem, Select } from "@mui/material";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useCouponsForm } from "./hooks/useCouponsForm";

export const SendCoupons = ({ changeAlert, partners, onConfirm, onClose, open, title }: SendCouponsProps & DefaultComponentProps) => {
	const { form, fileName, onHandleChange, onSelectFile, isValidForm } = useCouponsForm(open, changeAlert)
	
	const addFile = () => {
        document.getElementById('file').click();
    }

	return (
		<Dialog onClose={onClose} open={open} >
			<DialogTitle>
				<Typography variant="h2">{title}</Typography>
			</DialogTitle>
			<DialogContent>
				<FlexGrid container direction="column" alignItems='flex-start' spacing={2}>
					<FlexGrid container spacing={2} fullWidth>
						<Select value={form.partner_uuid || '-1'} onChange={onHandleChange.bind(this, "partner_uuid", "")} label="Partner" color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{width: "49%"}} >
							<MenuItem value={"-1"} disabled>Partner</MenuItem>
							{partners?.map((item, index) => {
								return <MenuItem key={`option-${index}`} value={item.k}>{item.v}</MenuItem>
							})}
						</Select>
						<TextField value={form.campaing_uuid} onInput={onHandleChange.bind(this, "campaing_uuid", "")} label="Campaña" color="secondary" sx={{width: "49%"}}/>
					</FlexGrid>
					<FlexGrid container spacing={2} fullWidth>
						<TextField value={form.description} onInput={onHandleChange.bind(this, "description", "")} label="Descripción" color="secondary" fullWidth/>
					</FlexGrid>
					<FlexGrid container spacing={2} fullWidth>
						<TextField value={(form.life_cycle.sdate).substring(0, 10)} onInput={onHandleChange.bind(this, "life_cycle", "sdate")} InputLabelProps={{ shrink: true }} type="date" style={{ flex: 1, cursor: "pointer" }} color="secondary" label="Vigencia - Inicio" />
						<TextField value={(form.life_cycle.edate).substring(0, 10)} onInput={onHandleChange.bind(this, "life_cycle", "edate")} InputLabelProps={{ shrink: true }} type="date" style={{ flex: 1 }} color="secondary" label="Vigencia - Fin" />
					</FlexGrid>
					<IconButton onClick={addFile.bind(this, "")} sx={{paddingLeft: "0 !important"}}>
						<AttachFileIcon /> <Typography variant="paragraph" style={{fontSize: 18, paddingLeft: 8}}>{fileName || "Adjuntar CSV"}</Typography>
						<input type="file" accept="text/csv" style={{display: 'none'}} id="file" onChange={onSelectFile.bind(this)} />
					</IconButton>
				</FlexGrid>
			</DialogContent>

			<DialogActions>
				<FlexGrid container fullHeight fullWidth justify='space-between' alignItems='flex-end' style={{ marginTop: '20px' }}>
					<FlexGrid item>
						<Button onClick={onClose} buttonType='secondary' size='normal'>
							Cancelar
						</Button>
					</FlexGrid>
					<FlexGrid item>
						<Button onClick={() => onConfirm(form)} disabled={isValidForm} size='normal'>
							Aceptar
						</Button>
					</FlexGrid>
				</FlexGrid>
			</DialogActions>
		</Dialog>
	)
}